import React from 'react';
import ReactDOM from 'react-dom/client';
import '@design/forma-studio-tokens.css';
import './portal.css';
import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
